import type { ClientProgramSurfaceOption } from "@solomon-apps/shared";

/**
 * Mock Program Surfaces shared with the sim-mode layer
 * (`services/sim/mockData.ts` re-exports and builds on these). The rest of
 * the old Add Position wizard preview fixtures were deleted with the
 * superseded `useAddPositionFlow` wizard; only this fixture has live
 * consumers.
 */

export const MOCK_PROGRAM_SURFACES: ClientProgramSurfaceOption[] = [
    {
        uuid: "surface-mock-meteora-dlmm",
        name: "USDV-USDC DLMM",
        displayName: "USDV–USDC DLMM",
        type: "DEX_LP",
        address: "DLMMpoo1MeteoraUSDVUSDC000000000000000000001",
        trailingApyPct: "14.20",
        tvl: "4820000",
        yaasProtocol: { uuid: "proto-meteora", name: "Meteora", slug: "meteora" }
    },
    {
        uuid: "surface-mock-treasury",
        name: "Solomon Treasury",
        displayName: "Solomon Treasury",
        type: "TREASURY",
        address: "TREASvau1tSo1omonLabs0000000000000000000002",
        trailingApyPct: "8.75",
        tvl: "12500000",
        yaasProtocol: { uuid: "proto-solomon", name: "Solomon", slug: "solomon" }
    },
    {
        uuid: "surface-mock-lending",
        name: "Kamino USDV Lend",
        displayName: "Kamino USDV Lend",
        type: "LENDING",
        address: "KAM1NoLendUSDV000000000000000000000000000003",
        trailingApyPct: "6.10",
        tvl: "2340000",
        yaasProtocol: { uuid: "proto-kamino", name: "Kamino", slug: "kamino" }
    }
];
